import React from 'react';
import ReferenceInput from 'components/ReferenceInput';
import EnumSelectInput from 'components/Enum/EnumSelectInput';
import {
  TextInput,
  NumberInput,
  BooleanInput,
  Create,
  SimpleForm,
  AutocompleteInput,
} from 'react-admin';

const PositionCreate = () => (
  <Create redirect="show" data-testid="position-create">
    <SimpleForm>
      <TextInput source="name" />
      <TextInput source="display_name" />
      <NumberInput source="sequence" />
      <EnumSelectInput source="kind" />
      <ReferenceInput reference="QualificationsGroup" source="qualifications_group_id">
        <AutocompleteInput optionText="name" />
      </ReferenceInput>
      <BooleanInput source="active" />
      <BooleanInput source="requires_specialty" />
      <TextInput source="responsibilities" />
      <TextInput source="lead_question" />
      <TextInput source="lead_description" />
    </SimpleForm>
  </Create>
);

export default PositionCreate;
